import React, { Component } from 'react';
import {
  Image,
  ImageBackground,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  Linking,
  TouchableOpacity,
  Button,
  View,
} from 'react-native';

import FirebaseUsers from '../firebase/firebase_users.js'
import Messaging from '../messaging.js';
import common from '../common.js';

import EonnTitle from '../components/title';
import EonnButton from '../components/button';
import TestRequestButton from '../components/test_request_button'; // TEMPORARY
import EonnLink from '../components/link';
import EonnField from '../components/field';
import PhoneField from '../components/phone_field';
import EonnCheckbox from '../components/checkbox';
import { mstyles } from '../constants/MainStyles';

export default class Screen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showRequired: false,
      err: "",
      emailError: false,
      pwError: false,
      password1: "",
      password2: "",
      countryCode: (global.techSignup && global.techSignup.countryCode) || "+1",
      smsConsent: false
    };
    console.log(global.user);
    
    
    // Initialize country code if not present on signup object
    if (!global.techSignup.countryCode) {
      global.techSignup.countryCode = "+1";
      this.state.countryCode = "+1";
    }
    
    // Extract country code from phone number if it exists
    const countryCodes = [
      { code: "+1", country: "US/Canada" },
      { code: "+44", country: "UK" },
      { code: "+61", country: "Australia" },
      { code: "+91", country: "India" },
      { code: "+33", country: "France" },
      { code: "+34", country: "Spain" },
      { code: "+49", country: "Germany" },
      { code: "+52", country: "Mexico" },
      { code: "+55", country: "Brazil" },
      { code: "+81", country: "Japan" },
      { code: "+82", country: "South Korea" },
      { code: "+86", country: "China" },
      { code: "+234", country: "Nigeria" },
    ];
    
    if (global.techSignup.phone && global.techSignup.phone.startsWith('+')) {
      // Find the matching country code from our list
      const matchedCountry = countryCodes.find(item => 
        global.techSignup.phone.startsWith(item.code));
      
      if (matchedCountry) {
        // Set the country code
        global.techSignup.countryCode = matchedCountry.code;
        this.state.countryCode = matchedCountry.code;
        
        // Remove the country code from the phone number
        global.techSignup.phone = global.techSignup.phone.substring(matchedCountry.code.length);
      }
    }
  }

  render() {
    return (
      <ScrollView style={mstyles.sContainer} contentContainerStyle={mstyles.sContent}>
        <EonnTitle>Create your profile</EonnTitle>
        {this.state.err
          ? <Text style={mstyles.err}>{this.state.err}</Text>
          : null
        }
        <EonnField
          onChange={value => Object.assign(global.techSignup,{ name:value }) }
          showRequired={this.state.showRequired}
          value={global.techSignup.name}
            >Name</EonnField>
        
        <PhoneField
          phoneValue={global.techSignup.phone}
          countryCode={this.state.countryCode}
          onPhoneChange={value => Object.assign(global.techSignup, { phone: value })}
          onCountryCodeChange={value => {
            this.setState({ countryCode: value });
            Object.assign(global.techSignup, { countryCode: value });
          }}
          showRequired={this.state.showRequired}
          countryCodes={[
            { code: "+1", country: "US/Canada" },
            { code: "+44", country: "UK" },
            { code: "+61", country: "Australia" },
            { code: "+91", country: "India" },
            { code: "+33", country: "France" },
            { code: "+34", country: "Spain" },
            { code: "+49", country: "Germany" },
            { code: "+52", country: "Mexico" },
            { code: "+55", country: "Brazil" },
            { code: "+81", country: "Japan" },
            { code: "+82", country: "South Korea" },
            { code: "+86", country: "China" },
            { code: "+234", country: "Nigeria" },
          ]}
        >
          Phone Number
        </PhoneField>


        <EonnField
          onChange={value => Object.assign(global.techSignup,{ email:value, emailError:false }) }
          showRequired={this.state.showRequired}
          showError={this.state.emailError}
          value={global.techSignup.email}
          textContentType={"emailAddress"}
          autoComplete={"email"}
          inputMode={"email"}
          keyboardType={"email-address"}
          >Email</EonnField>
        <EonnField
          onChange={value => this.setState({ password1: value, pwError:false }) }
          showRequired={this.state.showRequired}
          showError={this.state.pwError}
          value={this.state.password1}
          textContentType={"password"}
          secureTextEntry={true}
          >Password</EonnField>
        <EonnField
          onChange={value => this.setState({ password2: value, pwError:false }) }
          showRequired={this.state.showRequired}
          showError={this.state.pwError}
          value={this.state.password2}
          textContentType={"password"}
          secureTextEntry={true}
        >Re-Enter Password</EonnField>
        
        <EonnCheckbox
          checked={this.state.smsConsent}
          onChange={value => this.setState({ smsConsent: value })}
          showRequired={this.state.showRequired}
          labelStyle={{fontSize:14, lineHeight:18}}
        >
          By checking this box, I agree to receive SMS messages from Auto TeleTech with updates on my video consultation. Message frequency varies (approximately 2-5 messages per consultation). Message and data rates may apply. Reply STOP to opt-out. By continuing, you agree to our 
          {" "}<Text accessibilityRole="link" style={{ textDecorationLine: 'underline' }} onPress={() => Linking.openURL('https://www.autoteletech.com/terms.html')}>Terms</Text>
          {" "}and{" "}
          <Text accessibilityRole="link" style={{ textDecorationLine: 'underline' }} onPress={() => Linking.openURL('https://www.autoteletech.com/privacy.html')}>Privacy Policy</Text>.
        </EonnCheckbox>
        {/* TEMPORARY: test shortcut to the job request screen (remove with components/test_request_button.js) */}
        <TestRequestButton navigation={this.props.navigation} />

        <EonnButton
          loading={this.state.loading}
          navigationProps={this.props.navigation}
          showRequired={() => this.setState({ showRequired: true })}
          required={() => [
            global.techSignup.name,
            global.techSignup.phone,
            global.techSignup.email,
            this.state.password1,
            this.state.password2,
            this.state.smsConsent,
          ]}
          onPress={async () => {
            this.setState({ loading: true, err: "" });

            // Validate phone number
            let cleanPhone = global.techSignup.phone.replace(/[\s()-\.]/g, '');
            if (!/^[0-9]{6,12}$/.test(cleanPhone)) {
              this.setState({ err: "Please enter a valid phone number without the country code", loading: false });
              return;
            }

            // Validate email
            const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
            if (!emailRegex.test(global.techSignup.email)) {
              this.setState({ err: "Invalid email", loading: false });
              return;
            }

            if (this.state.password1 !== this.state.password2){
              this.setState({
                err: "Password fields don't match",
                pwError: true,
                emailError: false,
                loading: false,
             });
             return;
            }

            const fullPhone = this.state.countryCode + cleanPhone;
            global.techSignup.phone = fullPhone;
            global.techSignup.password = this.state.password1;
            global.techSignup.phoneVerified = false;
            global.user = global.techSignup;
            global.user.isTech = true;

            try {
              const result = await Messaging.sendPhoneVerificationCode(fullPhone);
              if (!result.ok) {
                const msg = (result.body && result.body.error) || "Could not send verification code. Please try again.";
                this.setState({ err: msg, loading: false });
                return;
              }
              global.techSignup.verifyToken = result.body.token;
              this.setState({ loading: false });
              this.props.navigation.navigate("T_Profile2_Verify");
            } catch (e) {
              console.error('sendPhoneVerificationCode error:', e);
              this.setState({ err: "Network error sending verification code. Please try again.", loading: false });
            }
          }}
          >
          Next</EonnButton>
      </ScrollView>
    );
  }
}